const convertToCelsius = (value) => {
  if (value) {
    return Math.round((value - 32) * (5 / 9));
  }
  return null;
}

export default convertToCelsius;
